<div syncGlobalBinds syncHideTools>
    <router-outlet>
        <!-- This needs to be uncommented when we fix the refresh prompt
        <div class="row" *ngIf="versionChanged">
            <sync-side-prompt-box></sync-side-prompt-box>
        </div> -->
    </router-outlet>
</div>
